// Customizer const
export const TAB_SIZE = 992
export const LIGHT_THEME = 'light'
export const DARK_THEME = 'dark'
